import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { INearyGaveUp } from './pages/INearyGaveUp';
export function AppRouter() {
  return <BrowserRouter data-id="element-16">
      <Routes data-id="element-17">
        <Route path="/" element={<App data-id="element-19" />} data-id="element-18" />
        <Route path="/i-nearly-gave-up" element={<INearyGaveUp data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}